import { ToSheetAnimation } from "@/components/r3f/animations/to-sheet-animation";
import { ModeTransitionProps } from "@/modes/mode";
import { useCurrentScene } from "@/modes/mode-data-context";
import { useState, type JSX } from "react";

/**
 *  @returns The transition from a mode to this one
 *  @param props The properties provided by the App during the transition
 */
export function FloorScaleModeTransition(
  props: ModeTransitionProps,
): JSX.Element {
  const { activeSheets, activeSheetFor2DNavigation } = useCurrentScene();

  const [placeholders] = useState(() => []);
  return (
    <ToSheetAnimation
      placeholders={placeholders}
      sheetElements={activeSheets}
      activeSheetFor2DNavigation={activeSheetFor2DNavigation}
      {...props}
    />
  );
}
